<div class="user-details-view-container" *ngIf="userObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).user.write" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button [disabled]="!(userPermissions | async).user.write || !userObject.active" (click)="sendInvitation()"mat-stroked-button color="primary"><mat-icon>email</mat-icon> <span> Wyślij zaproszenie</span></button>
    <button [disabled]="!(userPermissions | async).user.write" (click)="setAvatar()" mat-stroked-button color="primary"><mat-icon>file_upload</mat-icon> <span> Zmień zdjęcie</span></button>
    <button [disabled]="!(userPermissions | async).user.admin_root" (click)="getRemindPasswordUrl()" mat-stroked-button color="primary"><span> Wygeneruj link do resetu hasła</span></button>

  </div>


  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" [fxFlex]="!userObject.partnerId && !userObject.ofwcaId? 50 : 100" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row" fxLayoutGap="15px">
              <div>
                <div (click)="setAvatar()" class="user-avatar" *ngIf="userObject.avatar"
                     matRipple
                     [matRippleCentered]="false"
                     [matRippleDisabled]="false"
                     [matRippleUnbounded]="false"
                     [matRippleRadius]="10"
                     [matRippleColor]="'grey'" >
                  <img mat-card-avatar class="avatar" src="/rest/sso/api/user/{{userObject.uuid}}/avatar?{{imgCnt}}" alt="Zdjęcie"/>
                </div>
                <div>
                  <span fxFlex></span>
                </div>
                <input #avatarSelect type="file" style="display: none" [formControl]="avatarSelectControl"
                       accept=".jpg,.gif,.png,.jpeg"/>
              </div>
              <div>
                <h3>Dane użytkownika</h3>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Nazwa" [value]="userObject.username"></app-detail>
              </div>
              <div fxFlex="50">

                <app-detail header="Typ Użytkownika"
                            *ngIf="userObject.roles.includes('ROLE_ASF360')">ASF360 </app-detail>
                <app-detail header="Typ Użytkownika"
                            *ngIf="userObject.roles.includes('ROLE_ADMIN')">Admin </app-detail>
                <app-detail header="Typ Użytkownika"
                            *ngIf="userObject.roles.includes('ROLE_USER')">Pracownik </app-detail>

              </div>
            </div>


            <div fxLayout="row"  *ngIf="!userObject.roles.includes('ROLE_USER')">

              <div fxFlex="50">
                <app-detail-bool header="Partner" [value]="partnerToggle"></app-detail-bool>
              </div>

              <div fxFlex="50">
                <app-detail-bool header="OFWCA" [value]="ofwcaToggle"></app-detail-bool>
              </div>

            </div>

            <div   *ngIf="!userObject.roles.includes('ROLE_USER')">

              <div fxLayout="row">
                <div fxFlex="100" *ngIf="partnerToggle">
                  <app-detail header="Partner" [value]="partner?.fullName"></app-detail>
                </div>
              </div>

              <div fxLayout="row">
                <div fxFlex="100" *ngIf="ofwcaToggle">
                  <app-detail header="OFWCA" [value]="ofwca?.fullName"></app-detail>
                </div>
              </div>

            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Imię" [value]="userObject.firstName"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Nazwisko" [value]="userObject.lastName"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Numer telefonu" [value]="userObject.phone | phone"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Email" [value]="userObject.email"></app-detail>
              </div>
            </div>

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="50">-->
<!--                <app-detail header="Dział" [value]="userObject.department?.name"-->
<!--                            [link]="userObject.department ? ['/dzialy/szczegoly', userObject.department.uuid] : undefined"></app-detail>-->
<!--              </div>-->

<!--              <div fxFlex="50">-->
<!--                <app-detail header="Stanowisko" [value]="userObject.position"></app-detail>-->
<!--              </div>-->
<!--            </div>-->


            <div fxLayout="row">
              <div fxFlex="50">
                <app-detail-bool header="Aktywny" [value]="userObject.active"></app-detail-bool>
              </div>


              <div fxFlex="50">
                <app-detail-bool header="Uprawnienia Indywidualne" [value]="userObject.individualPermissions"></app-detail-bool>
              </div>
            </div>
            <div fxLayout="row">
              <div fxFlex="50">
                <app-detail-bool header="Google Authenticator 2FA" [value]="userObject.googleAuthenticatorEnabled"></app-detail-bool>
              </div>
              <div fxFlex="50" >
                <app-detail-bool header="Widoczny na liście kontaktów" [value]="userObject.employeeList360" ></app-detail-bool>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="50">
                <app-detail-bool header="Pracownik" [value]="userObject.employee"></app-detail-bool>
              </div>
            </div>

            <div fxLayout="row" *ngIf="userObject.roles.includes('ROLE_ASF360')">
              <div fxFlex="50" >
                <app-detail header="Kod dostępu " [value]="userObject?.smsCode" (click)="userObject?.smsCode"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" >
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Zakres danych ASF24</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Dział" [active]=false   [link]="['/uzytkownicy/dzialy/szczegoly', userObject.department?.uuid]" [value]="userObject.department?.name"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="!userObject.roles.includes('ROLE_ASF360')">
              <div fxFlex="100">
                <app-detail header="Regionalny" [value]="regionalName"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="!userObject.roles.includes('ROLE_ASF360')">
              <div fxFlex="100">
                <app-detail header="Tagi">
                  <ng-container *ngFor="let dict of tags; let last = last">
                    {{dict.name}}<ng-container *ngIf="!last">, </ng-container>
                  </ng-container>
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="!userObject.roles.includes('ROLE_USER') && (userPermissions | async).asf_360.read">
        <div fxFlex="100">
          <mat-card >
            <div fxLayout="row">
              <h3>Zakres danych ASF360</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="100">
                <app-detail header="Grupy uprawnień">
                  <mat-chip-list>
                    <ng-container *ngFor="let tag of permissionTag">
                      <mat-chip selected>{{tag.name}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Uuid Partnerów dobryagent.pl">
                  <mat-chip-list>
                    <ng-container *ngFor="let dobryAgentPartnerId of userObject?.dobryAgentPartnerId">
                      <mat-chip selected>{{dobryAgentPartnerId}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="!userObject.roles.includes('ROLE_ASF360')">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Konfiguracja kontaktu ASF360</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Stanowisko" [value]="userObject.position"></app-detail>
              </div>
            </div>



            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Dział 360" [value]="userObject.department360"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Tagi 360">
                  <ng-container *ngFor="let dict of tags360; let last = last">
                    {{dict.name}}<ng-container *ngIf="!last">, </ng-container>
                  </ng-container>
                </app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100" fxLayout="column">
                <div fxFlex="none">
                  <p class="text-md text-gray">Opis stanowiska</p>
                </div>
                <div fxFlex="none" [innerHTML]="userObject.positionDescription"></div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>


    </div>

  </div>
</div>
